import { gqlTagGira } from '@atlassian/jira-apollo-gira';
import { CONFLUENCE_LINKS_FRAGMENT } from '@atlassian/jira-business-confluence-pages';
import { JIRA_BUSINESS_TOP_LEVEL_FIELD_FRAGMENT } from '@atlassian/jira-business-fields';
import { CREATE_ISSUE_FRAGMENT } from '@atlassian/jira-business-issue-create';
import { LIST_VIEW_FIELDS_FRAGMENT } from '../get-list-view-issues/gql';

const CREATED_ITEM_FRAGMENT = gqlTagGira`
fragment CreatedListItemFragment on JiraWorkManagementViewItem {
    id
    issueId
    childSummary {
        hasChildren
        totalCount
    }
    commentSummary {
        totalCount
    }
    legacyConfluenceLinks(getFirstOnly: true) {
        ...ConfluenceLinksFragment
    }
    devSummaryCache @include(if: $isDevSummaryFieldVisible)  {
        ...DevSummaryFieldFragment
    }
    ...ListViewIssueFieldsFragment
}
${LIST_VIEW_FIELDS_FRAGMENT}
${CONFLUENCE_LINKS_FRAGMENT}
${JIRA_BUSINESS_TOP_LEVEL_FIELD_FRAGMENT}
`;

export const CREATE_ISSUE_MUTATION = gqlTagGira`

mutation JWMListInlineCreateIssue ($input: JiraCreateIssueInput!, $fieldIds: [String]!, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!, $withParentRank: Boolean = false,  $withParentIssueId: Boolean!) {
    createJiraBusinessIssue(input: $input, fieldIdsToReturn: $fieldIds) {
        item {
            ...CreatedListItemFragment
        }
        ...CreateIssueFragment
    }
}
${CREATE_ISSUE_FRAGMENT}
${CREATED_ITEM_FRAGMENT}
`;

export const ISSUE_REFETCH_QUERY = gqlTagGira`
query JWMListInlineCreateRefetchQuery($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!, $withParentRank: Boolean = false, $withParentIssueId: Boolean!) {
    jira {
        jwmViewItems(cloudId: $cloudId, jql: $jql, first: $first) {
            ... on JiraWorkManagementViewItemConnection {
                edges {
                    node {
                        ...CreatedListItemFragment
                    }
                }
            }
        }
    }
}
${CREATED_ITEM_FRAGMENT}
`;
